// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Stream = function Stream(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("g", {
      opacity: ".5"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M1.263 13.064H6.7a.561.561 0 010 1.12H1.263a.559.559 0 010-1.118zM12.667 13.064h1.385a.561.561 0 010 1.12h-1.385a.559.559 0 010-1.118z"
    })),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M13.425 5.295A4.409 4.409 0 009.137 1a4.347 4.347 0 00-4.03 2.83 3.779 3.779 0 00-.775-.107A2.774 2.774 0 001.645 6.55c0 .217.052.38.052.542A1.914 1.914 0 00.25 9a1.9 1.9 0 001.86 1.95h11.315c1.085 0 2.325-1.412 2.325-2.825a2.745 2.745 0 00-2.325-2.83zM10.1 7.025l-2.575 1.85-.01.007a.35.35 0 01-.485-.1.384.384 0 01-.062-.21v-3.7a.359.359 0 01.355-.365.35.35 0 01.2.068L10.1 6.428a.37.37 0 010 .6z"
    }),
    /*#__PURE__*/
    React.createElement("circle", {
      cx: "9.633",
      cy: "13.624",
      r: "1.322"
    }))
  );
};

export default Stream;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Stream.js
// module id = 1054
// module chunks = 0